var _path, _path2, _path3, _circle;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCustomerCare(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56019 14.2791V10.2626C6.5552 9.44225 6.69309 8.62885 6.96593 7.86928C7.23877 7.1097 7.64116 6.41897 8.14993 5.83686C8.6587 5.25475 9.26379 4.79277 9.93036 4.47752C10.5969 4.16227 11.3118 3.99998 12.0338 4C12.7532 4 13.4656 4.16116 14.1302 4.47426C14.7948 4.78737 15.3985 5.24627 15.9069 5.82473C16.4153 6.40318 16.8183 7.08984 17.0929 7.84543C17.3676 8.60102 17.5084 9.41073 17.5074 10.2282V13.437V15.7071C17.5074 17.1024 16.3763 18.2334 14.9811 18.2334L13.819 18.2334",
    stroke: "#ACACB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5076 9.45318L18.6406 9.45318C18.9334 9.45098 19.2238 9.51177 19.4949 9.63204C19.766 9.75232 20.0126 9.9297 20.2203 10.154C20.4281 10.3783 20.593 10.645 20.7055 10.9388C20.8181 11.2327 20.876 11.5478 20.876 11.8661V11.8661C20.876 12.1833 20.8185 12.4973 20.7067 12.7903C20.5949 13.0832 20.4311 13.3494 20.2247 13.5735C20.0182 13.7976 19.7731 13.9752 19.5034 14.0963C19.2337 14.2174 18.9447 14.2795 18.6529 14.279L17.5076 14.279",
    stroke: "#ACACB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56032 9.45318L5.42727 9.45318C5.13445 9.45098 4.84411 9.51177 4.57299 9.63204C4.30187 9.75232 4.05532 9.9297 3.84754 10.154C3.63977 10.3783 3.47487 10.645 3.36234 10.9388C3.24981 11.2327 3.19189 11.5478 3.19189 11.8661V11.8661C3.19189 12.1833 3.24942 12.4973 3.36118 12.7903C3.47294 13.0832 3.63674 13.3494 3.84321 13.5735C4.04968 13.7976 4.29478 13.9752 4.56448 14.0963C4.83418 14.2174 5.12319 14.2795 5.41499 14.279L6.56032 14.279",
    stroke: "#ACACB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7842,
    cy: 18.0679,
    r: 1.93218,
    stroke: "#ACACB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomerCare);
export default __webpack_public_path__ + "static/media/icon_customer_care.985d64bbe535b20ecf56a8127aac97f1.svg";
export { ForwardRef as ReactComponent };